// extracted by mini-css-extract-plugin
module.exports = {"settingBtn":"settingBtn___60_jB","icon":"icon___Vb5zX","disable":"disable___2wVC9"};